import localeEnGb from '@angular/common/locales/en-GB';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeBg from '@angular/common/locales/bg';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localePt from '@angular/common/locales/pt';
import localeEs from '@angular/common/locales/es';
import localeTr from '@angular/common/locales/tr';
import localeNl from '@angular/common/locales/nl';
import localeEt from '@angular/common/locales/et';
import localeKk from '@angular/common/locales/kk';
import localeRu from '@angular/common/locales/ru';
import localeZh from '@angular/common/locales/zh';
import { registerLocaleData } from '@angular/common';
import { AVAILABLE_LANGUAGES } from '@shared/constants/translations/translations.constants';

/**
 * Centralized locale configuration for the application.
 *
 * Responsibilities:
 * - Registers all Angular locale data required for date/time formatting;
 * - Resolves the active locale based on the User's browser settings.
 *
 * Behavior:
 * - Uses `navigator.language` to detect the User's preferred locale (browser language);
 * - Matches the detected locale against the list of supported languages;
 * - Falls back to `en-GB` if no match is found.
 *
 * Notes:
 * - Angular requires locale data to be registered explicitly for non-default locales (the default one is , it
 * - The matching is language-based (e.g. "en-US" matches "en").
 * - Keep this file in sync with AVAILABLE_LANGUAGES.
 */

export function registerAppLocales(): void {
  registerLocaleData(localeEnGb);
  registerLocaleData(localeEn);
  registerLocaleData(localeDe);
  registerLocaleData(localeBg);
  registerLocaleData(localeFr);
  registerLocaleData(localeIt);
  registerLocaleData(localePt);
  registerLocaleData(localeEs);
  registerLocaleData(localeTr);
  registerLocaleData(localeNl);
  registerLocaleData(localeEt);
  registerLocaleData(localeKk);
  registerLocaleData(localeRu);
  registerLocaleData(localeZh);
}

export function getAppLocale(): string {
  // Get the browser language, not necessarily the physical location
  const browserLang: string = window.navigator.language || 'en-GB';

  // Check if we support this language
  const isSupported: boolean = AVAILABLE_LANGUAGES.some((lang) => browserLang.startsWith(lang.toLowerCase()));

  // Safe fallback to `en-GB`
  return isSupported ? browserLang : 'en-GB';
}
